import { PersonHttpHelper, NO_DATA_MESSAGE } from '../../utils/HttpHelper';

const DeletePersonPhoneData = (personPhoneId, state, setState) => {
  if (state.isSaving !== true && !state.message) {
    const newState = {
      ...state,
      isSaving: true,
      isSaved: false,
      message: 'Deleting...'
    };
    setState(newState);

    const personPhoneIdForUrl = personPhoneId ? encodeURIComponent(personPhoneId) : 'NaN';
    const url = `/PersonPhone/${personPhoneIdForUrl}`;
    PersonHttpHelper(url, 'DELETE')
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isSaving: false,
            isSaved: true,
            objData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isSaving: false,
          isSaved: false,
          message: message
        });
      });
  }
};

export default DeletePersonPhoneData;